import React from 'react';
import { Link, useTheme } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { TypographyProps } from '@mui/material/Typography';

interface InternalLinkProps {
  to:string
  title?: string
  color?: TypographyProps['color']
  variant?: TypographyProps['variant']
}

const InternalLink:React.FC<React.PropsWithChildren<InternalLinkProps>> = ({
  to,
  children,
  title,
  variant = 'subtitle2'
}) => {
  const theme = useTheme();
  return (
    <Link
      color={theme.palette.primary.main}
      variant={variant}
      title={title}
      component={RouterLink}
      to={to}
    >
      {children}
    </Link>

  );
};

export default InternalLink;
